import ChevronUpIcon from '@heroicons/react/outline/esm/ChevronUpIcon.js'
import ThumbUpIcon from '@heroicons/react/outline/esm/ThumbUpIcon.js'
import { clsx } from 'clsx'

import { Post, ReactionType } from '@tribeplatform/gql-client/types'
import { analyticsNumberFormatter } from '@tribeplatform/react-components/Analytics/utils'

const reactionIcon: Record<keyof typeof ReactionType, JSX.Element> = {
  [ReactionType.VOTE_BASE]: <ChevronUpIcon className="h-5 w-5" />,
  [ReactionType.LIKE_BASE]: <ThumbUpIcon className="h-5 w-5" />,
  [ReactionType.EMOJI_BASE]: <ThumbUpIcon className="h-5 w-5" />,
}

interface Props {
  post: Post
  highlighted: boolean
  stretchX: string
}
export const ReactionCount = ({ post, highlighted, stretchX }: Props) => {
  return (
    <div
      className={clsx(
        'flex space-s-2 text-content-subdued items-center empty:hidden',
        highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
        stretchX,
      )}
    >
      {reactionIcon?.[post?.primaryReactionType] ?? (
        <ThumbUpIcon className="h-5 w-5" />
      )}
      <span>{analyticsNumberFormatter(post?.reactionsCount ?? '0')}</span>
    </div>
  )
}
